import axios from 'axios';

const ENDPOINT = '/api/v1/contributor';

export function followContributor(profileId, exp) {
  const data = exp ? { exp } : undefined;
  return axios.post(`${ENDPOINT}/${profileId}/_follow`, data);
}

export function unfollowContributor(profileId) {
  return axios.post(`${ENDPOINT}/${profileId}/_unfollow`);
}
